import { AwsUi } from '../../../core/runtime/src';
import { TokenGroup } from '../../token/src';
import { TokenToggle } from './token-toggle';
import { isOptionDisabled } from '../../dropdown/src/utils/options';
export var Tokens = function (_a) {
    var controlId = _a.controlId, deselectLabel = _a.deselectLabel, disabled = _a.disabled, i18nStrings = _a.i18nStrings, isExpanded = _a.isExpanded, onClick = _a.onClick, selectedOptions = _a.selectedOptions, allOptions = _a.allOptions, tokenLimit = _a.tokenLimit;
    var numberOfHiddenOption = selectedOptions.length - tokenLimit;
    var hasHiddenOption = typeof tokenLimit === 'number' && numberOfHiddenOption > 0;
    var displayedOptions = hasHiddenOption && !isExpanded ? selectedOptions.slice(0, tokenLimit) : selectedOptions;
    var items = displayedOptions.map(function (option) {
        // Spread can't be used to pass the option to the object because, in GWT, the option properties are non-enumerable, and they are in their prototype
        return {
            tags: option.tags,
            labelTag: option.labelTag,
            label: option.label,
            iconUrl: option.iconUrl,
            iconName: option.iconName,
            iconAlt: option.iconAlt,
            description: option.description,
            __labelPrefix: option.__labelPrefix,
            dismissLabel: deselectLabel ? deselectLabel(option) : null,
            disabled: disabled || isOptionDisabled(option, allOptions)
        };
    });
    return (AwsUi.__createElement("div", null,
        AwsUi.__createElement("div", { id: controlId },
            AwsUi.__createElement(TokenGroup, { items: items })),
        hasHiddenOption && (AwsUi.__createElement(TokenToggle, { controlId: controlId, areAllHidden: tokenLimit === 0, isExpanded: isExpanded, numberOfHiddenOption: numberOfHiddenOption, i18nStrings: i18nStrings, onClick: onClick }))));
};
//# sourceMappingURL=tokens.js.map